module.exports = __webpack_public_path__ + "static/assets/f78eb96e212fcc1c94888c1633043586.svg";